import { statuses } from '@/returns/constants'

export const getLineItemStatus = ({ item, acceptAll, rejectAll, forReviewAll }) => {
  if (acceptAll) return statuses.accepted

  if (rejectAll) return statuses.rejected

  if (forReviewAll) return statuses.forReview

  return item.status
}
